import React from 'react';
import { Download, X } from 'lucide-react';
import { saveChatImage } from '../../utils/download';
import './image-viewer.css';

export function ImageViewer({ src, name, onClose }: { src: string; name?: string; onClose: () => void }) {
  return (
    <div className="chat-image-viewer" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="chat-image-viewer-bar" onClick={(e) => e.stopPropagation()}>
        <strong>{name || '图片'}</strong>
        <div>
          <button className="chat-image-viewer-btn" title="保存图片" onClick={() => saveChatImage(src, name || '余白图片.png')}>
            <Download size={18} />
          </button>
          <button className="chat-image-viewer-btn" title="关闭" onClick={onClose}>
            <X size={18} />
          </button>
        </div>
      </div>
      <img src={src} alt={name || '图片'} onClick={(e) => e.stopPropagation()} />
    </div>
  );
}
